<script lang="ts">
	import type { OperationModel } from '../../../models/api/OperationModel';
	import { capitalize } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';

	export let operation: OperationModel;
</script>

{#if operation.outingsStrategy}
	<section>
		<h2>{capitalize($t('operation.outingsStrategy'))}</h2>
		<p>{capitalize(operation.outingsStrategy)}</p>
		<p class="text-sm text-grey-dark">{capitalize($t('operation.noGuaranty'))}</p>
	</section>
{/if}
